import React from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { change } from "redux-form";

import { Alert, Button } from "components";
import { uiActions } from "store";

const InfoSection = ({
	setWebsiteUpdatedValue,
	businessFormName,
}: {
	setWebsiteUpdatedValue: Function;
	businessFormName: string;
}) => {
	const dispatch = useDispatch<any>();

	const showUpdateWebsiteModal = () => {
		dispatch(
			uiActions.showModal("UPDATE_WEBSITE", {
				title: "Add Missing Data",
				onConfirm(values) {
					setWebsiteUpdatedValue?.(values?.website);
					dispatch(
						change(businessFormName, "website", values?.website),
					);
				},
			}),
		);
	};

	return (
		<Row>
			<Col xl={9} lg={12}>
				<Alert
					variant="default"
					message={
						<div className="py-1 font-italic text-white">
							Required data is missing . To activate Network
							Tokenization Website is required.{"   "}
							<Button
								value="Provide now?"
								disabled={false}
								onClick={() => {
									showUpdateWebsiteModal();
								}}
								className="p-0 mb-1 text-left text-capitalize"
								variant="secondary"
							/>
						</div>
					}
					className="mb-2"
				/>
			</Col>
		</Row>
	);
};

export default InfoSection;
